export default __webpack_public_path__ + "assets/images/fed00b770a68f1120f7b533620d42819.svg";